import { NowDateTime, OnlyDateString } from "../lib";
import {
    downloadAllDocs,
    downloadCertficate,
    downloadContract,
    downloadDocument,
    downloadLibraryDocument,
    exportCsvService,
    generateContractService,
} from "../services";

export const downloadZip = async (dossierId: number) => {
    const downloadingAllDocsRes = await downloadAllDocs(dossierId);
    await download(downloadingAllDocsRes, "Documents");
};

export const _downloadLibraryDocument = (
    libraryDocumentId: number,
    fileName: string
) => {
    (async () => {
        const response = await downloadLibraryDocument(libraryDocumentId);
        //fileName = getFileNameFromBlob(response);
        await download(response.data, fileName);
    })();
};

export const _download = (documentId: number, fileName: string) => {
    (async () => {
        const response = await downloadDocument(documentId);
        await download(response.data, fileName);
    })();
};

export const _downloadCertificate = (dossierId: number, fileName: string) => {
    (async () => {
        const response = await downloadCertficate(dossierId);
        await download(response.data, fileName);
    })();
};

export const _downloadContract = (dossierId: number, fileName: string) => {
    (async () => {
        const response = await downloadContract(dossierId);
        fileName = response.headers["file-name"];
        await download(response.data, fileName);
    })();
};

export const exportCsv = async (userRoleId?: number | null, establishmentGroup?: number | null, region?: number | null) => {
    const response = await exportCsvService(userRoleId, establishmentGroup, region);
    const exportCsvFileName =
        "export-" + OnlyDateString(NowDateTime().toString());
    await download(response.data, exportCsvFileName);
};

export const generateContract = (dossierId: number, fileName: string) => {
    (async () => {
        const response = await generateContractService(dossierId);
        fileName = response.headers["file-name"];
        await download(response.data, fileName);
    })();
};

const download = async (fileData: any, fileName: string) => {
    if (fileData) {
        const url = window.URL.createObjectURL(fileData);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
    }else{
        console.error("No such file to download");
    }
   
};

export const extractDocumentPdfName = (url: string): string => {
    const ext = ".pdf";
    const indexPdf = url.lastIndexOf(ext);
    const indexSlash = url.lastIndexOf("/");

    if (indexPdf !== -1 && indexSlash !== -1 && indexSlash < indexPdf) {
        return url.substring(indexPdf, indexSlash + 1) + ext;
    }

    return ""; // Retourne null si la séquence n'est pas trouvée
};
